import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import EndOfOverPopupDetails from './EndOfOverPopupDetails.vue'

export const EndOfOverPopup = new PopupBuilder('Do you want to end this over?')
  .appendBody(EndOfOverPopupDetails)
  .build()
